import React from 'react';
import {OrderProductType, OrdersType} from '../../../types/TypesStore';
import s from './TableElements.module.css';
import SubTotalInfo from './SubTotalInfo';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

type Props = {
	order: OrdersType | any;
	active: boolean;
	handleClick?: any;
};
const TableFullViewProductEl: React.FC<Props> = ({order, active}) => {
	const {t} = useTranslation();
	return (
		<>
			<div
				className={s.productDetailsContainer}
				style={{display: active ? 'block' : 'none'}}
			>
				<div className={s.productDetailsHeader}>
					<div className={s.productDetailsColumn}></div>
					<div className={s.productDetailsColumn}>{t('Назва')}</div>
					<div className={s.productDetailsColumn}>{t('Кількість')}</div>
					<div className={s.productDetailsColumn}>{t('Всього вартість')}</div>
					<div className={s.productDetailsColumn}>{t('Всього бали')}</div>
				</div>
				{order?.products?.map((product: OrderProductType, index: number) => (
					<div
						className={s.productDetailsRow}
						key={`product${product.id}order${order.id}${index}`}
					>
						<div className={s.productDetailsColumn}>
							<img
								src={product.href}
								alt={product.name}
								className={s.productImage}
							/>
						</div>
						<div className={s.productDetailsColumn}>{product.name}</div>
						<div className={s.productDetailsColumn}>{product.count}</div>
						<div className={s.productDetailsColumn}>{product.money} грн</div>
						<div className={s.productDetailsColumn}>{product.points} Б</div>
					</div>
				))}
			</div>
			{active && (
				<div className={s.subTotalWrapper}>
					<SubTotalInfo
						bonuses={order.points}
						comment={order.comment}
						money={order.money}
						currency={order.currency}
						cashback={order.cashback}
						bonus={order.bonus}
						createDate={order.create_date}
					/>
				</div>
			)}
		</>
	);
};

export default TableFullViewProductEl;
